import {
  ArrayNotEmpty,
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
} from 'class-validator';
import { BaseCreateDto, BaseDto, BaseUpdateDto } from './base.dto';

export interface SmartPhrasesDto extends BaseDto {
  diagnosisId: string;
  recommendedActionId: string;
  recommendedActionDetails?: string;
  phrase: string;
  recommendedAction: { parentActionId?: string | null };
}

export class SearchSmartPhrasesDto {
  @IsOptional()
  @IsUUID('all', { each: true })
  @ArrayNotEmpty()
  diagnosesIds?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  @ArrayNotEmpty()
  recommendedActionsIds?: string[];

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  phrase?: string;

  @IsOptional()
  @IsString()
  recommendedActionDetails?: string;

  @IsOptional()
  @IsNumber()
  @Max(30)
  take?: number;

  @IsOptional()
  @IsNumber()
  skip?: number;

  @IsOptional()
  @IsBoolean()
  mostAccurateMatchOnly?: boolean;
}

export class CreateSmartPhrasesDto
  extends BaseCreateDto
  implements Partial<SmartPhrasesDto>
{
  @IsUUID()
  @IsNotEmpty()
  diagnosisId: string;

  @IsUUID()
  @IsNotEmpty()
  recommendedActionId: string;

  @IsString()
  @IsNotEmpty()
  phrase: string;

  @IsOptional()
  @IsString()
  recommendedActionDetails?: string;
}

export class UpdateSmartPhrasesDto
  extends BaseUpdateDto
  implements Partial<SmartPhrasesDto>
{
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  phrase?: string;
}
